import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';

import { McpServiceComponent } from './McpServiceComponent';
import { TReconnectConfig } from '../../types/reconnection-config';

export const McpReconnectionConfig: TReconnectConfig = {
  serviceComponent: McpServiceComponent,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED],
};
